import { Observable } from 'rxjs';

export class S3Upload {

    static upload(signedUrl: string, file: Blob): Observable<boolean> {
        const o = new Observable<boolean>(obs => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', signedUrl, true);

            xhr.upload.onprogress = (event) => {
              if (event.lengthComputable) {
                const percent = Math.round((event.loaded / event.total) * 100);
                console.log(percent);
              }
            };
            xhr.onerror = (ev) => obs.error(ev);
            xhr.onload = () => {
              if (xhr.status === 200) {
                obs.next(true);
                obs.complete();
              } else {
                obs.error(xhr);
              }
            };
            xhr.send(file);
        });
        return o;
    }

    static awsMetadataPrefix: string = "x-amz-meta-";

    static uploadWithMetadata(signedUrl: string, file: Blob, metadata: Map<string, string>): Observable<boolean> {
      const o = new Observable<boolean>(obs => {
          const xhr = new XMLHttpRequest();
          xhr.open('PUT', signedUrl, true);

          metadata.forEach((value, name) =>  {
            if (value){
              xhr.setRequestHeader(`${this.awsMetadataPrefix}${name}`,value);
            }
          })

          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
              const percent = Math.round((event.loaded / event.total) * 100);
              console.log(percent);
            }
          };
          xhr.onerror = (ev) => obs.error(ev);
          xhr.onload = () => {
            if (xhr.status === 200) {
              obs.next(true);
              obs.complete();
            } else {
              obs.error(xhr);
            }
          };
          xhr.send(file);
      });
      return o;
  }
}
